import { useId } from "react";
import { useSettingsStore } from "@/state/settings.ts";
import styles from "./countdown.module.css";

/** Matches `persistedSettingsSchema`: positive, and not more hours than a week has. */
const MIN_HOURS = 0.5;
const MAX_HOURS = 168;

/**
 * The one input the pace math can't work without: how much time you actually
 * have. It lives in the bar rather than the filter panel because it belongs to
 * the same sentence as the numbers it moves — change it and every leg
 * re-reads on the next tick.
 *
 * (PLAN §6 lists a fuller `BudgetPlanner` in the control panel for v0.2; this
 * is the countdown's own always-visible version of the same setting.)
 */
export function PaceBudget() {
  const hoursPerWeek = useSettingsStore((state) => state.hoursPerWeek);
  const setHoursPerWeek = useSettingsStore((state) => state.setHoursPerWeek);
  const id = useId();

  return (
    <div className={styles.budget}>
      <label className={styles.budgetLabel} htmlFor={id}>
        I can watch
      </label>
      <input
        id={id}
        className={styles.budgetInput}
        type="number"
        inputMode="decimal"
        min={MIN_HOURS}
        max={MAX_HOURS}
        step={0.5}
        value={hoursPerWeek}
        onChange={(event) => {
          const hours = Number(event.target.value);
          // An empty or half-typed field parses to NaN; keep the last good value
          // rather than dividing the whole bar by nothing.
          if (!Number.isFinite(hours) || hours <= 0) return;
          setHoursPerWeek(Math.min(MAX_HOURS, hours));
        }}
      />
      <span className={styles.budgetUnit}>h/week</span>
    </div>
  );
}
